import type { Plugin } from '@nuxt/types';

import type { AlgoliaSearchContext, AlgoliaSearchModuleOptions } from './types';

declare module 'vue/types/vue' {
  interface Vue {
    $algoliaSearch: AlgoliaSearchContext;
  }
}

declare module '@nuxt/types' {
  interface Context {
    $algoliaSearch: AlgoliaSearchContext;
  }
}

const algoliaSearchPlugin: Plugin = (_context, inject) => {
  const options = JSON.parse('{"appId":"K6BBC9405Y","apiKey":"7312c29eac893ccad29c63f4b1e44150","analyticsApiKey":"821d9f595cc8ea5a8f57712e803842a4","envName":"stage","contentfulPagesEnvName":"stage","localeConfigs":{"en_eu":{"appId":"K6BBC9405Y","apiKey":"7312c29eac893ccad29c63f4b1e44150","analyticsApiKey":"821d9f595cc8ea5a8f57712e803842a4"},"fr_fr":{"appId":"K6BBC9405Y","apiKey":"7312c29eac893ccad29c63f4b1e44150","analyticsApiKey":"821d9f595cc8ea5a8f57712e803842a4"},"fr_eu":{"appId":"K6BBC9405Y","apiKey":"7312c29eac893ccad29c63f4b1e44150","analyticsApiKey":"821d9f595cc8ea5a8f57712e803842a4"},"es_eu":{"appId":"K6BBC9405Y","apiKey":"7312c29eac893ccad29c63f4b1e44150","analyticsApiKey":"821d9f595cc8ea5a8f57712e803842a4"},"it_eu":{"appId":"K6BBC9405Y","apiKey":"7312c29eac893ccad29c63f4b1e44150","analyticsApiKey":"821d9f595cc8ea5a8f57712e803842a4"},"de_eu":{"appId":"K6BBC9405Y","apiKey":"7312c29eac893ccad29c63f4b1e44150","analyticsApiKey":"821d9f595cc8ea5a8f57712e803842a4"},"en_us":{"appId":"0PQ2ZOJ5U4","apiKey":"037026137aced8d2e8b7b9c6a7fce05f","analyticsApiKey":"8af1c1fd327c12b5747160bf453c182c"},"fr_us":{"appId":"0PQ2ZOJ5U4","apiKey":"037026137aced8d2e8b7b9c6a7fce05f","analyticsApiKey":"8af1c1fd327c12b5747160bf453c182c"},"ja_jp":{"appId":"USFYMPA04D","apiKey":"b02a9f12ea62b9d5010872d5f8bfe422","analyticsApiKey":"a107ef94ece42794fe4cc6584a3fc81e"},"en_hk":{"appId":"USFYMPA04D","apiKey":"b02a9f12ea62b9d5010872d5f8bfe422","analyticsApiKey":"a107ef94ece42794fe4cc6584a3fc81e"},"zh_hk":{"appId":"USFYMPA04D","apiKey":"b02a9f12ea62b9d5010872d5f8bfe422","analyticsApiKey":"a107ef94ece42794fe4cc6584a3fc81e"}}}') as AlgoliaSearchModuleOptions;
  const {
    appId: defaultAppId,
    apiKey: defaultApiKey,
    analyticsApiKey: defaultAnalyticsApiKey,
    envName,
    contentfulPagesEnvName,
    localeConfigs = {}
  } = options;

  inject('algoliaSearch', {
    defaultAppId,
    defaultApiKey,
    defaultAnalyticsApiKey,
    envName,
    contentfulPagesEnvName,
    localeConfigs
  });
};

export default algoliaSearchPlugin;
